import React from 'react';
import { JcColumn } from '../JcBox';
import { JcResponsiveGrid } from '../JcResponsiveGrid';
import { JcTitle } from '../JcTitle';
import { JcCommonProps, JcUtils } from '../../utils/JcUtils';

export interface JcCardGroupProps extends JcCommonProps {
    readonly title: string;
    /** Minimum card width (px) before the grid drops a column. */
    readonly minItemWidth?: number;
    readonly children: React.ReactNode;
}

/** A titled section of cards in an auto-fitting grid. */
export const JcCardGroup = (props: JcCardGroupProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-card-group"]);
    return <JcColumn {...commonProps} spacing role="region" ariaLabel={props.title}>
        <JcTitle className="jc-card-group-title" title={props.title} />
        <JcResponsiveGrid spacing minItemWidth={props.minItemWidth}>
            {props.children}
        </JcResponsiveGrid>
    </JcColumn>;
};
